<template>
    <div>
		<div v-if="typeof $route.params.ads_ex_id=='undefined'">
			

			<div><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/></div>
			<div class="col-md-12" v-show="bShowFilter">
				<ReFilter :masAllFilterParams="masAllFilterParams" 
				v-model="objGetParams" 
				v-on:filterapply="OnFilterApply"
				name="adssource"
				/>
			</div>
			

			<card>
				<h4>Добавить</h4>
				<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" />
			</card>

			<h6 class="mt-3 mb-3 text-right">Площадок найдено: {{this.masObjects_total}}</h6>

			<card 
				v-loading.fullscreen.lock="$GVO.fullscreenLoading"
				element-loading-text="Загрузка данных..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"	>
				<el-table ref="adssourceTable" :data="ApiData" style="width: 100%;">
					<el-table-column
						label="ID"
						property="id"
						width="80"
					>
					</el-table-column>
					<el-table-column 
							min-width="180"
							label="Номер телефона"
							property="phone"
					>
					</el-table-column>
					<el-table-column 
							min-width="180"
							label="Источник"
							property="adsSource_id"
					>
						<!-- <template slot-scope="scope">
							{{ arrMediaSource[scope.row.adsSource_id].label }}
						</template> -->
						<template v-slot="scope">
						{{ scope.row.adsSource_id }}
						</template>
					</el-table-column>
					<el-table-column 
							min-width="180"
							label="Дата от"
							property="dt_from"
					>
						<template v-slot="scope">
						{{ $GVO.convertDateTimeFromMysql(scope.row.dt_from) }}
						</template>
					</el-table-column>
					<el-table-column 
							min-width="180"
							label="Дата до"
							property="dt_to"
					>
						<template v-slot="scope">
						{{ $GVO.convertDateTimeFromMysql(scope.row.dt_to) }}
						</template>
					</el-table-column>

					<el-table-column 
							min-width="180"
							label="Площадка"
							property="site_name"
					>
					</el-table-column>
					
					<el-table-column
							width="160"
							label="Действие"
							align="right"                    	
					>
						<template v-slot="scope">			
							<el-tooltip content="Изменить" placement="top" >
								<el-button class="no-border my-0">
									<button class="ml-3 btn btn-icon btn-simple btn-success" @click="GoEdit(scope.row)">
										<i class="tim-icons icon-pencil"></i>
									</button>											
								</el-button>
							</el-tooltip>		
							<el-tooltip content="Удалить" placement="top">
								<el-button class="no-border my-0">
									<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="DeleteRow(scope.row)">
										<i class="tim-icons icon-trash-simple"></i>
									</button>											
								</el-button>
							</el-tooltip>		
						</template>
					</el-table-column>
				
				</el-table>
				<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
					:type="'info'" 
					:total="parseInt(masObjects_total)*parseInt(count2page)" 
					:perPage="parseInt(count2page)"
					:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
					:pClick="pClick">
				</Pagination>
				<!-- <pre>{{ ApiData }}</pre> -->
			</card>
		</div>
		<div v-else>
			<card>
				<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" />
			</card>
		</div>
    </div>
</template>
<script>
import swal from 'sweetalert2';
import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
import Pagination from 'src/our_components/RePagination';

export default {
	name: 'adsSourceExtendMap-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		ReFilterBtn,
        ReFilter,
        ReFormPrinter,
        Pagination,
	},
	data() {
		return {
			ApiData: [],
			bShowFilter: false,
			objGetParams:{},
			masAllFilterParams: this.currentFilterConfig(),
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			arrMediaSource: [],
			masObjects_total: 0,
			count2page: 10,
			fullscreenLoading: false,
		};
	},
	methods: {
		getApiData(){
			// for (const key in this.objGetParams) {
			// 	if (Object.hasOwnProperty.call(this.objGetParams, key)) {
			// 		if(this.objGetParams[key] == '') delete this.objGetParams[key];
			// 	}
			// }
			// let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			// // console.log('getApiData',strItogGetParams,this.objGetParams);
			// this.$router.push({path: location.pathname+'?'+strItogGetParams});

			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				filter = this.objGetParams;
			}

			this.$GVO.ApiCall('adsSourceExtendMap.GET',{flt:{'list':'true', act:1, ...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					this.masObjects_total = 0;
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
					}else{
						this.ApiData = [];
						this.masObjects_total=0;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		currentFormConfig() {
			let result_id = typeof this.$route.params.ads_ex_id=='undefined'?null:this.$route.params.ads_ex_id;
			this.$GVO.ApiCall('adsSourceExtendMap.GET_FORM_MODEL',{flt:{'result_id':result_id}})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
			let result_id = typeof this.$route.params.ads_ex_id=='undefined'?'0':this.$route.params.ads_ex_id;
            return {apiMethod:'adsSourceExtendMap.INSUPD',apiParam:{iData:[],flt:{'id':result_id}}};
        },
		SuccessGo(evt,dopParam){
	        this.masAllFormParams = this.currentFormConfig();
			this.getApiData();
		},
		DeleteRow(row){
			// console.log(row);
			if(row.id != null){
				
				this.$GVO.ApiCall('adsSourceExtendMap.DEL',{ flt:{id: row.id}}) 
					.then((objApi) => {
						if(objApi.success === true){
							this.getApiData();
						}else{
							// console.log(objApi);
							this.$GVO.showAlert('У Вас не достаточно прав доступа на редактирование модуля',objApi.msg);
							// alert('Не удалилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
				// if(this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.OperatorCC == 1){}else {
				// 	this.$GVO.showAlert('Загрузка файлов',objApi.msg);
				// 	swal({
				// 			title: 'Ошибка редактирования',
				// 			buttonsStyling: false,
				// 			confirmButtonClass: 'btn btn-danger btn-fill',
				// 			text:`У Вас не достаточно прав доступа на редактирование модуля`,
				// 		});
				// }
			}
		},
		GoEdit(row){
			//console.log(row);
			if(row.id != null){
				if(this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.MasterCC == 1){
					this.$router.push({path: `/data/settings/adsSourceExtendMap/${row.id}`});
				} else {
					// this.$GVO.showAlert('Загрузка файлов',objApi.msg);
					swal({
							title: 'Ошибка редактирования',
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-danger btn-fill',
							text:`У Вас не достаточно прав доступа на редактирование модуля`,
						});
				}
				
			}
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			// this.getApiData();
			this.OnFilterApply();
		},
		OnFilterApply(data){
			//console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},
		currentFilterConfig(){
			//return require("src/conf/cellraspredFilter.js").super_config;
			this.$GVO.ApiCall('adsSourceExtendMap.GET_FILTER',{})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						//console.log(objApi.config[0].elements[objApi.config[0].elements.length-1]);
						this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 10000);
		},
	},		
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		this.$GVO.ApiCall('cat.GET_MEDIA_SOURCE_CAT',{ flt:{}}) 
			.then((objApi) => {
				if(objApi.success === true){
					//console.log(objApi.data);
					this.arrMediaSource = {};
					for (let i = 0; i < objApi.data.length; i++) {
						const element = objApi.data[i];
						this.arrMediaSource[element.value] = element;
					}
					this.getApiData();
				}
			}).catch(errorObjApi => {console.error(errorObjApi);});
	}
};
</script>
<style>
</style>
